module.exports = __webpack_public_path__ + "img/the-rugby-company-category.f40bfda4.jpg";